import Vue from 'vue';
import * as TYPES from './types';
import http from '@/utils/api';
import Auth from '@/utils/auth';


const namespaced = true;

const state = {
  loading: false,
  ordersLoading: false,
  stores: [],
  orders: {},
  currentStore: {
    store: {},
  },
};

const getters = {
  stores: ({ stores }) => stores,
  storeById: ({ stores }) => id => stores.find(store => id === store.id),
};

const actions = {
  async fetchStores({ commit }) {
    commit(TYPES.SET_LOADING, true);

    try {
      const response = await http.get('/logistic/shops', {
        headers: {
          'Authorization': Auth.getAuthHeader(),
        },
      });

      if (response) {
        commit(TYPES.SET_LOADING, false);
        commit(TYPES.ADD_STORES, response.data);
      }
    } catch (e) {
      console.log(e);
    }
  },

  async fetchStore({ commit }, id) {
    commit(TYPES.SET_LOADING, true);

    try {
      const { data } = await http.get('/logistic/shopInfo', {
        headers: {
          'Authorization': Auth.getAuthHeader(),
        },
        params: {
          id,
        },
      });

      if (data) {
        commit(TYPES.SET_LOADING, false);
        commit(TYPES.SET_CURRENT_STORE, data);
      }
    } catch (e) {
      console.log(e);
    }
  },

  async fetchOrdersByType({ commit }, { id, ordersType }) {
    commit(TYPES.SET_ORDERS_LOADING, true);

    try {
      const { data } = await http.get('/logistic/deviceInfo', {
        headers: {
          'Authorization': Auth.getAuthHeader(),
        },
        params: {
          id,
          tag: ordersType,
        },
      });

      if (data) {
        const { orders } = data;

        commit(TYPES.ADD_ORDERS, { ordersType, orders });
        commit(TYPES.SET_ORDERS_LOADING, false);
      }
    } catch (e) {
      console.log(e);
    }
  },
  async handleGetXLSX({ commit }) {
    commit(TYPES.SET_LOADING, true);
    try {
      const { data } = await http.get('/logistic/getXLSX', {
        headers: {
          'Authorization': Auth.getAuthHeader(),
        },
      });

      const { path } = data;
      commit(TYPES.SET_LOADING, false);
      if(path) window.open(path, '_blank');
      // window.open('api/v1/AllDevices-08.07.2020.xlsx', '_blank');
    } catch (e) {
      commit(TYPES.SET_LOADING, false);
      console.log(e);
    }
  },
  async handleGetGradeXLSX({ commit }) {
    commit(TYPES.SET_LOADING, true);
    try {
      const { data } = await http.get('/logistic/getSamsungXLSX', {
        headers: {
          'Authorization': Auth.getAuthHeader(),
        },
      });

      const { path } = data;
      commit(TYPES.SET_LOADING, false);
      if(path) window.open(path, '_blank');
    } catch (e) {
      commit(TYPES.SET_LOADING, false);
      console.log(e);
    }
  },
  async getDocumentURL({ commit }, btags) {
    commit(TYPES.SET_LOADING, true);
    try {
      const { data } = await http.post('/logistic/getMoscowDocuments', {
        btags,
      }, {
        headers: {
          'Authorization': Auth.getAuthHeader(),
        },
      });

      const { actDoc, ProxyDoc, actExel } = data;
      commit(TYPES.SET_LOADING, false);
      if(actDoc) window.open(actDoc, '_blank');
      if(ProxyDoc) window.open(ProxyDoc, '_blank');
    } catch (e) {
      commit(TYPES.SET_LOADING, false);
      console.log(e);
    }
  },
  async changeToReceivedURL({ commit }, btags) {
    try {
      const { data } = await http.put('/logistic/accepted', {
        btags,
      }, {
        headers: {
          'Authorization': Auth.getAuthHeader(),
        },
      });
    } catch (e) {
      console.log(e);
    }
  },
};

const mutations = {
  [TYPES.SET_LOADING](state, status) {
    state.loading = status;
  },
  [TYPES.SET_ORDERS_LOADING](state, status) {
    state.ordersLoading = status;
  },
  [TYPES.ADD_STORES](state, stores) {
    Vue.set(state, 'stores', stores);
  },
  [TYPES.ADD_ORDERS](state, { ordersType, orders }) {
    Vue.set(state, 'orders', { ...state.orders, [ordersType]: orders });
  },
  [TYPES.SET_CURRENT_STORE](state, data) {
    Vue.set(state, 'currentStore', data);
  },
};


export default {
  namespaced,
  actions,
  state,
  mutations,
  getters,
};
